import { Component, OnInit } from '@angular/core';
import { SmmService } from '../../../_services/smm.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ReportService } from 'app/_services/report.service';
import { ToastrService } from 'ngx-toastr';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';
const moment = require('moment');
@Component({
  selector: 'app-dashboard5',
  templateUrl: './dashboard5.component.html',
  styleUrls: ['./dashboard5.component.scss']
})

export class Dashboard5Component implements OnInit {
  listPosts = [];
  spamFilter = true;
  sourceByTopicFilter = true;
  isDashboard5 = true;
  chu_de_thao_luan_filter = true;
  filterSentiment = true;
  currentPage = 0;
  currentFilter = null;
  totalRecommandPost = 0;
  dtOptions: DataTables.Settings = {};
  currentPost = null;
  brandFilter = true; // Item filter thương hiệu

  links = [];
  titles = [];

  posts = [];

  showLoadMore = true;

  modalRef: BsModalRef;

  public cardHoverStates: boolean[] = [];

  constructor( public dashboardFilterService : DashboardFilterService, private postService: SmmService,  private toastrService: ToastrService, private modalService: BsModalService, private reportService: ReportService) { }
  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0], 'searchable': true }
      ]
    };

  }

  public onCardHover(index: number) {
    this.cardHoverStates[index] = true;
  }

  public onCardLeave(index: number) {
    this.cardHoverStates[index] = false;
  }

  onFilterChange(filter) {
    this.showLoadMore = true;
    this.currentFilter = filter;
    this.listPosts = [];
    this.currentPage = 0;
    if(filter.projectsDisscussionSelected.length  <= 1) {
      let newsFilter = {
        gte: filter.gte,
        lte: filter.lte,
        size: 10,
        from: this.currentPage,
        sentiment : this.currentFilter.sentiment,
        projects : this.currentFilter.projectsSelected,
        discussProjects : this.currentFilter.projectsDisscussionSelected ? this.currentFilter.projectsDisscussionSelected : [],
        typeTime : this.currentFilter.typeTime,
        notSpam : this.currentFilter.notSpam,
        sourceByTopic: this.currentFilter.sourceByTopic,
  
        // brands: this.currentFilter.brandsSelected
      };
      this.getDataFromServer(newsFilter);
    } else {
      this.toastrService.warning("Vui lòng chọn tối đa 1 chủ đề thảo luận", "Thông báo")
    }

  }


  clickReportBK() {
    this.dashboardFilterService.openLoader(true);
    let topicId = '';
    this.listPosts.forEach(item => {
      topicId = topicId + " " + item.key.topicId;
    });
    topicId = topicId.trim();
    // console.log(topicId);
    let filter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: 3000,
      topicId : topicId,
      from: 0
    };

    let result = [];

    this.postService.getArticleTopic({ filter: filter }).subscribe(res => {
      if (res.success) {
        res.data.hits.hits.forEach(item => {
          item._source.titles.forEach((element, _index) => {
            result.push({
              topic: item._source.topicSentiment.length ? item._source.topicSentiment[0].topic : '-',
              domain: (item._source.links &&item._source.links[_index]) ? new URL(item._source.links[_index]).host : '-',
              title : element,
              link: (item._source.links &&item._source.links[_index]) ? item._source.links[_index] : '',
              createDate: item._source.createDate ? item._source.createDate : '-',
              sentiment : this.getSentiment(item._source.topicSentiment)
            })
          });
        });


        let dataReport = [];

        let header =  [
          { start: 1 },
          { name: 'STT' },
          {name : 'Chủ đề'},
          { name: 'Nguồn báo' },
          { name: 'Tiêu Đề' },
          { name: 'Link' },
          { name: 'Ngày phát hành' },
          { name: 'Sắc thái' }
      
        ];
        // header.unshift({ start: 1 });
        dataReport.push({ name: 'Báo cáo nội dung nổi bật', header: [header], data: result });
        //   }
        // }
        if (dataReport.length > 0 && topicId) {
          this.reportService.exportReportToExcel(dataReport, `Báo cáo nội dung nổi bật`);
        } else {
          this.toastrService.warning('Dữ liệu không tồn tại để xuất báo cáo', 'Thông báo')
        }

        this.dashboardFilterService.openLoader(false);
      }
    });
  }

  clickReport() {
    this.dashboardFilterService.openLoader(true);
    let topicId = '';
    this.listPosts.forEach(item => {
      topicId = topicId + " " + item.key.topicId;
    });
    topicId = topicId.trim();
    // console.log(topicId);
    let filter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: 3000,
      topicId : topicId,
      from: 0,
      typeTime: this.currentFilter.typeTime
    };

    let result = [];

    this.postService.getArticleTopic({ filter: filter }).subscribe(res => {
      if (res.success) {
        res.data.hits.hits.forEach(item => {
          item._source.titles.forEach((element, _index) => {
            result.push({
              //topic: item._source.topicSentiment.length ? item._source.topicSentiment[0].topic : '-',
              topic: this.getProject(item._source.topicSentiment),
              //topicSentimentDiscuss: item._source.topicSentimentDiscuss.length ? item._source.topicSentimentDiscuss[0].discuss : '-', // chủ đề thảo luận
              topicSentimentDiscuss: this.getProjectDiscuss(item._source.topicSentimentDiscuss),
              topic2: item._source.content? item._source.content.split('@@@@')[0] : '', // Topic
              domain: (item._source.links &&item._source.links[_index]) ? new URL(item._source.links[_index]).host : '-',
              title : element,
              summary : item._source.summary? item._source.summary : "", // tóm tắt nội dung
              link: (item._source.links &&item._source.links[_index]) ? item._source.links[_index] : '-',
              //createDate: item._source.createDate ? moment(item._source.createDate).format('DD/MM/YYYY') : '-',
              createDate: (filter.typeTime == "create_date")? moment(item._source.createDate).format('DD/MM/YYYY') : item._source.shortformDate,
              sentiment : this.getSentiment(item._source.topicSentiment),
              language : "Tiếng Việt"
            })
          });
        });


        let dataReport = [];

        let header =  [
          { start: 1 },
          { name: 'STT' },
          {name : 'Chủ đề'},
          {name : 'Chủ đề thảo luận'}, // thêm
          {name : 'Topic'}, // thêm
          { name: 'Nguồn báo' },
          { name: 'Tiêu Đề' },
          { name: 'Tóm tắt nội dung' }, // thêm
          { name: 'Link bài' },
          { name: 'Ngày phát hành' }, //format
          { name: 'Phân loại tin' },
          { name: 'Ngôn ngữ' } // thêm
      
        ];
        // header.unshift({ start: 1 });
        dataReport.push({ name: 'Báo cáo nội dung nổi bật', header: [header], data: result });
        //   }
        // }
        if (dataReport.length > 0 && topicId) {
          this.reportService.exportReportToExcel(dataReport, `Báo cáo nội dung nổi bật`);
        } else {
          this.toastrService.warning('Dữ liệu không tồn tại để xuất báo cáo', 'Thông báo')
        }

        this.dashboardFilterService.openLoader(false);
      }
    });
  }

  exportExcelDetail() {
    let dataReport = [];

    let header =  [
      { start: 1 },
      { name: 'STT' },
      { name: 'Nguồn báo' },
      { name: 'Tiêu Đề' },
      { name: 'Link' },
      { name: 'Ngày phát hành' },
      { name: 'Sắc thái' }
  
    ];
    // header.unshift({ start: 1 });
    dataReport.push({ name: 'Báo cáo link tồn', header: [header], data: this.posts });
    //   }
    // }
    if (dataReport.length && this.posts.length) {
      this.reportService.exportReportToExcel(dataReport, `Báo cáo chi tiết bài viết`);
    } else {
      this.toastrService.warning('Dữ liệu không tồn tại để xuất báo cáo', 'Thông báo')
    }
  }

  getDataFromServer(filter) {
    this.dashboardFilterService.openLoader(true);
    this.postService.groupArticleTopic({ filter: filter }).subscribe(res => {
      if (res.success) {
        if(res.data.aggregations.my_buckets.buckets.length < 10) {
          this.showLoadMore = false;
        }
        this.listPosts = this.listPosts.length == 0 ? res.data.aggregations.my_buckets.buckets : this.listPosts.concat(res.data.aggregations.my_buckets.buckets);

        for(let post of this.listPosts){
          let content_0 = post.key.content.split('@@@@')[0];
          let content_1 = post.key.content.split('@@@@')[1] || post.key.content.split('@@@@')[0];
          if(content_0.length > 130){
            content_0 = content_0.substr(0, 130) + " ...";
          }
          if(content_1.length > 170){
            content_1 = content_1.substr(0, 170) + " ...";
          }
          post["content_0"] = content_0;
          post["content_1"] = content_1;
        }

      //  this.totalRecommandPost = res.data.hits.total.value;
      }
      this.dashboardFilterService.openLoader(false);
    });
  }

  showModalDetail(topicId, modalRef,count) {

    let filter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: 2000,
      topicId : topicId,
      from: 0,
      
      // badv bổ sung thêm
      sentiment : this.currentFilter.sentiment,
      projects : this.currentFilter.projectsSelected,
      discussProjects : this.currentFilter.projectsDisscussionSelected ? this.currentFilter.projectsDisscussionSelected : [],
      typeTime : this.currentFilter.typeTime,
      notSpam : this.currentFilter.notSpam
    };
    this.links = [];
    this.titles = [];
    this.posts = [];

    this.postService.getArticleTopic({ filter: filter }).subscribe(res => {
      if (res.success) {
        res.data.hits.hits.forEach(item => {
            item._source.titles_by_date.forEach((element, _index) => {
              this.posts.push({
                domain: (item._source.links_by_date &&item._source.links_by_date[_index]) ? new URL(item._source.links_by_date[_index]).host : '-',
                title : element,
                link: (item._source.links_by_date &&item._source.links_by_date[_index]) ? item._source.links_by_date[_index] : '',
                //createDate: item._source.shortformDate ? item._source.shortformDate : '-',
                createDate: (filter.typeTime == "create_date")? moment(item._source.createDate).format('DD-MM-YYYY') : item._source.shortformDate,
                sentiment : this.getSentiment(item._source.topicSentiment)
              })
            });
        })
      }
    });

    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
    backdrop: 'static',   
      class: 'modal-lg'
    });
  }

  getSentiment(topicSentiment) {
    const sentiments = {
      pos: 'Tích cực',
      neu: 'Trung tính',
      neg: 'Tiêu cực'
    }
    if (!topicSentiment.length) {
      return '-';
    }
    if (this.currentFilter.projectsSelected && this.currentFilter.projectsSelected.length) {
      const sentiment = topicSentiment.find(x => x.id == this.currentFilter.projectsSelected[0].id);
      return sentiments[sentiment.sentiment];
    } else {
      return sentiments[topicSentiment[0].sentiment];
    }
  }

  getProject(topicSentiment) {
    if (!topicSentiment.length) {
      return '-';
    }
    if (this.currentFilter.projectsSelected && this.currentFilter.projectsSelected.length) {
      const sentiment = topicSentiment.find(x => x.id == this.currentFilter.projectsSelected[0].id);
      return sentiment.topic;
    } else {
      //return topicSentiment[0].topic;
      return '-';
    }
  }

  getProjectDiscuss(topicSentimentDiscuss) {

    console.log(this.currentFilter.projectsDisscussionSelected)
    if (!topicSentimentDiscuss || !topicSentimentDiscuss.length) {
      return '-';
    }
    if (this.currentFilter.projectsDisscussionSelected && this.currentFilter.projectsDisscussionSelected.length) {
      const sentiment = topicSentimentDiscuss.find(x => x._id == this.currentFilter.projectsDisscussionSelected[0].id);
      return sentiment.discuss;
    } else {
      // return topicSentimentDiscuss[0].discuss;
      return '-';
    }
  }

  clickLoadMore() {
    this.currentPage++;
    let newsFilter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: 10,
      from: this.currentPage * 10,
      sentiment : this.currentFilter.sentiment,
      projects : this.currentFilter.projectsSelected,
      discussProjects : this.currentFilter.projectsDisscussionSelected ? this.currentFilter.projectsDisscussionSelected : [],
      notSpam : this.currentFilter.notSpam
      // brands: this.currentFilter.brandsSelected
      // sentiment: [this.typeSentimentPost],
      // brands: []
    };
    this.getDataFromServer(newsFilter);
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard5/dashboard5.component.ts